/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

import { ComponentActionModel } from '@app/models/component-action.model';

export class ComponentPermissionsModel {
  private _componentId?: string;
  private _componentName?: string;
  private _componentPath?: string;
  private _componentClass?: string;
  private _componentDescription?: string;
  private _componentIsShared?: boolean;
  private _componentOwnerId?: string;
  private _sonraiOnly?: boolean;
  private _componentActions?: ComponentActionModel[];

  constructor(
    componentId?: string,
    componentName?: string,
    componentPath?: string,
    componentClass?: string,
    componentDescription?: string,
    componentIsShared?: boolean,
    componentOwnerId?: string,
    sonraiOnly?: boolean,
    componentActions?: ComponentActionModel[]
  ) {
    this.componentId = componentId;
    this.componentName = componentName;
    this.componentPath = componentPath;
    this.componentClass = componentClass;
    this.componentDescription = componentDescription;
    this.componentIsShared = componentIsShared;
    this.componentOwnerId = componentOwnerId;
    this.sonraiOnly = sonraiOnly;
    this.componentActions = componentActions;
  }

  get componentId(): string {
    return this._componentId;
  }

  set componentId(value: string) {
    this._componentId = value;
  }

  get componentName(): string {
    return this._componentName;
  }

  set componentName(value: string) {
    this._componentName = value;
  }

  get componentPath(): string {
    return this._componentPath;
  }

  set componentPath(value: string) {
    this._componentPath = value;
  }

  get componentClass(): string {
    return this._componentClass;
  }

  set componentClass(value: string) {
    this._componentClass = value;
  }

  get componentDescription(): string {
    return this._componentDescription;
  }

  set componentDescription(value: string) {
    this._componentDescription = value;
  }

  get componentIsShared(): boolean {
    return this._componentIsShared;
  }

  set componentIsShared(value: boolean) {
    this._componentIsShared = value;
  }

  get componentOwnerId(): string {
    return this._componentOwnerId;
  }

  set componentOwnerId(value: string) {
    this._componentOwnerId = value;
  }

  get sonraiOnly(): boolean {
    return this._sonraiOnly;
  }

  set sonraiOnly(value: boolean) {
    this._sonraiOnly = value;
  }

  get componentActions(): ComponentActionModel[] {
    return this._componentActions;
  }

  set componentActions(value: ComponentActionModel[]) {
    this._componentActions = value;
  }

  toJson(): Object {
    const componentActions = [];
    for (const action of this.componentActions) {
      componentActions.push(action.toJson().toString());
    }
    const object = {
      component_id: this.componentId,
      component_name: this.componentName,
      component_path: this.componentPath,
      component_class: this.componentClass,
      component_description: this.componentDescription,
      component_is_shared: this.componentIsShared,
      component_owner_id: this.componentOwnerId,
      sonrai_only: this.sonraiOnly,
      component_actions: componentActions,
    };
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }

  fromJson(input: any): ComponentPermissionsModel {
    const componentActions = [];
    const componentAction = new ComponentActionModel();
    if (input['component_actions']) {
      for (const action of input['component_actions']) {
        componentActions.push(componentAction.fromJson(action));
      }
    }
    return new ComponentPermissionsModel(
      input['component_id'],
      input['component_name'],
      input['component_path'],
      input['component_class'],
      input['component_description'],
      input['component_is_shared'],
      input['component_owner_id'],
      input['sonrai_only'],
      componentActions
    );
  }
}
